import React from "react";
import { Flame, Crown, Sparkles } from "lucide-react";
import { useAuth } from "../lib/auth-context";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_maaya-reset/artifacts/t6ziwuh2_MAYAVERSE%20-%20LOGOS%20%286%29.png";

export const Header = ({ streak = null }) => {
  const { user, isPro, trialActive, trialDaysRemaining } = useAuth();
  return (
    <header className="px-6 pt-7 pb-4 flex items-center justify-between gap-3" data-testid="app-header">
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={LOGO_URL}
          alt="Maayaveda logo"
          className="w-12 h-12 object-contain shrink-0"
          data-testid="brand-logo"
        />
        <div className="min-w-0">
          <h1
            className="text-xl font-medium text-[#1A2E24] leading-tight truncate"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="brand-title"
          >
            Daily Reset
          </h1>
          <p className="text-[11px] text-[#5C7568] mt-0.5 leading-tight">
            by <span className="font-semibold text-[#D6336C]">Maayaveda</span>
            <span className="text-[#5C7568]"> · from Maayaverse</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {trialActive ? (
          <div
            className="rounded-full bg-[#234B38] text-white px-3 py-1.5 text-[10px] font-semibold flex items-center gap-1.5"
            data-testid="trial-badge"
            title={`Trial ends in ${trialDaysRemaining} day${trialDaysRemaining === 1 ? "" : "s"}`}
          >
            <Sparkles className="w-3 h-3" />
            <span>Trial · {trialDaysRemaining}d</span>
          </div>
        ) : isPro ? (
          <div className="rounded-full bg-[#234B38] text-white px-3 py-1.5 text-[10px] font-semibold flex items-center gap-1.5" data-testid="pro-badge">
            <Crown className="w-3 h-3" /> Pro
          </div>
        ) : (
          <div className="rounded-full bg-white border border-[#E2EBE6] text-[#5C7568] px-3 py-1.5 text-[10px] font-semibold" data-testid="free-badge">
            Free
          </div>
        )}
        {streak !== null && (
          <div
            className="rounded-full bg-[#F5D0D6] text-[#234B38] px-3 py-1.5 text-xs font-semibold flex items-center gap-1.5"
            data-testid="streak-badge"
          >
            <Flame className="w-3.5 h-3.5" />
            <span data-testid="streak-count">{streak}</span>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
